class Cart {
  constructor() {
    this.toggle = document.querySelector('.code-promo-toggle');
    this.content = document.querySelector('.code-promo-content');
    this.chevronUp = document.querySelector('#chevron-up');
    this.chevronDown = document.querySelector('#chevron-down');
    this.woocommerceMessage = document.querySelectorAll('.woocommerce-message');
    // this.updateCartButton = document.querySelector('#update-cart-button');
    this.events();
  }
  events() {
    this.couponToggleClicked();
    this.hideWoocommerceMessageAfterDelay();
    this.changeUpdateCartButtonColors();
  }

  changeUpdateCartButtonColors() {
    if (this.updateCartButton) {
      //   console.log(this.updateCartButton.ariaDisabled);
      if (this.updateCartButton.ariaDisabled) {
        console.log('aria');
      } else {
        console.log('yes');
      }
      //   if (this.updateCartButton.getAttribute('aria-disabled')) {
      // console.log('aria');
      // const ariaProperty = this.updateCartButton.getAttribute(
      //   'aria-disabled'
      // );
      // if (ariaProperty) {
      //   this.updateCartButton.classList.add('bg-red-500');
      // }
      //   }
    }
  }

  couponToggleClicked() {
    if (this.toggle && this.content && this.chevronDown && this.chevronUp) {
      this.toggle.addEventListener('click', () => {
        this.content.classList.contains('hidden')
          ? this.content.classList.remove('hidden')
          : this.content.classList.add('hidden');
        this.chevronDown.classList.contains('hidden')
          ? this.chevronDown.classList.remove('hidden')
          : this.chevronDown.classList.add('hidden');
        this.chevronUp.classList.contains('hidden')
          ? this.chevronUp.classList.remove('hidden')
          : this.chevronUp.classList.add('hidden');
      });
    }
  }
  hideWoocommerceMessageAfterDelay() {
    if (this.woocommerceMessage) {
      this.woocommerceMessage.forEach((message) => {
        setTimeout(function () {
          message.style.display = 'none';
        }, 3000);
      });
    }
  }
}
export default Cart;
